function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#74DAFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0070DF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "path-2",
  x: 0,
  y: 0,
  width: 64,
  height: 64,
  rx: 32
}), /*#__PURE__*/React.createElement("filter", {
  x: "-85.9%",
  y: "-54.7%",
  width: "271.9%",
  height: "271.9%",
  filterUnits: "objectBoundingBox",
  id: "filter-3"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 20,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.329350825 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "10.10\\u6700\\u7EC8",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5F00\\u53D1\\u8005\\u670D\\u52A1\\u5E73\\u53F0-10.14",
  transform: "translate(-656.000000, -1311.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-16",
  transform: "translate(-92.000000, 1273.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-3",
  transform: "translate(457.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5F00\\u53D1\\u8005",
  transform: "translate(321.000000, 48.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u77E9\\u5F62"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-3)",
  xlinkHref: "#path-2"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#linearGradient-1)",
  fillRule: "evenodd",
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "xtrace",
  transform: "translate(12.800000, 12.800000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\u77E9\\u5F62",
  fill: "#000000",
  opacity: 0,
  x: 0,
  y: 0,
  width: 38.4,
  height: 38.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.0736,19.8336 C26.6304,20.7936 27.6672,21.4272 28.8768,21.4272 C30.6432,21.4272 32.0832,19.9872 32.0832,18.2208 C32.0832,16.4544 30.6432,15.0144 28.8768,15.0144 C27.1104,15.0144 25.6704,16.4544 25.6704,18.2208 C25.6704,18.4512 25.6704,18.7008 25.7472,18.9504 L23.5776,19.9872 C23.0208,19.0272 21.888,18.3936 20.6976,18.2208 L20.6976,19.7376 L19.8144,19.7376 L19.8144,18.24 C18.624,18.3936 17.568,19.0464 17.0112,19.9296 L14.688,18.816 L14.2848,19.6224 L16.608,20.736 C16.4544,21.216 16.3776,21.6192 16.3776,22.0992 C16.3776,22.5792 16.4544,22.9824 16.608,23.4624 L14.9376,24.2688 L14.304,24.5952 L14.7072,25.4016 L17.0304,24.288 C17.2608,24.6912 17.5872,25.0176 17.9904,25.3248 C18.5472,25.728 19.1808,25.9584 19.8336,26.0544 L19.8336,24.864 L20.7168,24.864 L20.7168,26.1504 C21.5232,26.0736 22.3104,25.6704 22.9632,25.1136 C23.2128,24.864 23.4432,24.6336 23.5968,24.3072 L25.5168,25.2672 L25.8432,25.4208 C25.7664,25.6704 25.7664,25.824 25.7664,26.0544 C25.7664,27.0912 26.6496,27.9744 27.6864,27.9744 C28.7232,27.9744 29.6064,27.0912 29.6064,26.0544 C29.6064,25.0176 28.6464,24.0576 27.5328,24.0576 C26.976,24.0576 26.496,24.3072 26.1696,24.6144 L23.8464,23.5008 C23.9232,23.424 23.9232,23.2512 23.9232,23.0976 C24,22.7712 24.0768,22.5408 24.0768,22.2144 C24.0768,21.888 24,21.5808 23.9232,21.2544 C23.9232,21.1776 23.8464,21.024 23.8464,20.928 L26.0736,19.8336 L26.0736,19.8336 Z",
  id: "\\u8DEF\\u5F84",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.7568,12 L19.7568,17.3568 L20.64,17.3568 L20.64,12 C22.7904,11.7696 24.48,9.9264 24.48,7.6032 C24.48,5.2032 22.4832,3.2064 20.0832,3.2064 C17.6832,3.2064 15.6864,5.2032 15.6864,7.6032 C15.7632,9.9264 17.5296,11.7504 19.7568,12 Z M11.5968,18.4704 L13.44,19.4304 L13.8432,18.624 L11.9232,17.5872 C12,17.3568 12,17.1072 12,16.8576 C12,15.0912 10.56,13.6512 8.7936,13.6512 C7.0272,13.6512 5.5872,15.0912 5.5872,16.8576 C5.5872,18.624 7.0272,20.064 8.7936,20.064 C10.0032,20.0832 11.04,19.4304 11.5968,18.4704 Z M13.5168,25.0368 L10.8864,26.3232 C10.56,25.92 10.0032,25.6896 9.4464,25.6896 C8.4096,25.6896 7.5264,26.5728 7.5264,27.6096 C7.5264,28.6464 8.4096,29.5296 9.4464,29.5296 C10.4832,29.5296 11.3664,28.6464 11.3664,27.6096 L11.3664,27.2064 L14.016,25.8432 C13.9968,25.8432 13.5168,25.0368 13.5168,25.0368 L13.5168,25.0368 Z M20.64,30.1632 L20.64,27.2832 L19.7568,27.2832 L19.7568,30.1632 C18.5664,30.3168 17.6064,31.3536 17.6064,32.64 C17.6064,34.0032 18.72,35.1936 20.16,35.1936 C21.5232,35.1936 22.7136,34.08 22.7136,32.64 C22.6368,31.4496 21.7536,30.3936 20.64,30.1632 L20.64,30.1632 Z",
  id: "\\u5F62\\u72B6",
  fill: "#FFFFFF"
})))))));

function SvgGroup12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "124px",
    viewBox: "0 0 124 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5F00\u53D1\u8005") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup12);
export default __webpack_public_path__ + "static/media/group1_2.b9502335.svg";
export { ForwardRef as ReactComponent };